module.exports = __webpack_public_path__ + "static/logo_text-d0f23612fb150c9dc81e10ca3b9710f2.svg";